export default __webpack_public_path__ + "static/uxqcc_2_ilija_bojchovikj-a638fca22be6d06344a745a8afd0a6c5.png";